import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function inventoryListModel() {
  const fetchInventoryList = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/List",
    method: "POST",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
    },
  });

  const fetchEntryMasterList = reactive({
    api: apiEndpoint.bcrm_platform + "/InventoryMaster/Entry_List",
    method: "POST",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
    },
  });

  const fetchEntryInventoryList = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Entry_List",
    method: "POST",
    payload: {
      Inventory_Id: 0,
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
    },
  });

  const fetchReorderList = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/Reorder",
    method: "POST",
    payload: {
      Inventory_Id: null, //required
      Privilege_Id: null, //required
      From: null, //required
      To: null, //required
    },
  });

  return {
    fetchInventoryList,
    fetchEntryMasterList,
    fetchReorderList,
    fetchEntryInventoryList
  };
}
